import { z } from "zod";
import {
	isoCountryCodeSchema,
	sanitizedEmailSchema,
	sanitizedNullableString,
} from "../validation";

export const billingDetailsUpdateSchema = z
	.object({
		organizationId: z.string().uuid(),
		email: sanitizedEmailSchema.optional(),
		firstName: sanitizedNullableString({ max: 120 }),
		lastName: sanitizedNullableString({ max: 120 }),
		company: sanitizedNullableString({ max: 160 }),
		phone: sanitizedNullableString({ max: 32 }),
		vatNumber: sanitizedNullableString({ max: 32 }),
		line1: sanitizedNullableString({ max: 255 }),
		line2: sanitizedNullableString({ max: 255 }),
		city: sanitizedNullableString({ max: 120 }),
		state: sanitizedNullableString({ max: 120 }),
		zip: sanitizedNullableString({ max: 32 }),
		country: isoCountryCodeSchema,
		einvoiceAddress: sanitizedNullableString({ max: 50 }),
		einvoiceOperator: sanitizedNullableString({ max: 50 }),
	})
	.strict();

export type BillingDetailsUpdateInput = z.infer<
	typeof billingDetailsUpdateSchema
>;
